var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-editor"},[_c('ckeditor',{ref:"editorInstance",staticClass:"textarea-editor",style:(`height: ${_vm.multipleRows ? '180px' : 'unset'}`),attrs:{"editor":_vm.editor,"config":_vm.editorConfig},model:{value:(_vm.editorValue),callback:function ($$v) {_vm.editorValue=$$v},expression:"editorValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }